import { useTranslation } from 'react-i18next'
import React from 'react'

import Center from '../../components/helpers/Center'
import IconBlock from '../../components/presentation/IconBlock'
import Loading from '../../components/helpers/Loading'

const ErrorMessage = ({ error }) => {
  const { t } = useTranslation('common')

  return (
    <Center>
      <IconBlock icon="BsExclamationTriangle" title={t('errorMessage')} subtitle={error} />
    </Center>
  )
}

const EmptyMessage = () => {
  const { t } = useTranslation('common')

  return (
    <Center>
      <IconBlock icon="BsInbox" title={t('emptyMessage')} />
    </Center>
  )
}

export const defaultLoaderRender = ({ waiting, error, empty, loading, loadingMore }) => {
  if (!!waiting) return false
  if (!!error) return <ErrorMessage error={error} />
  if (!!empty) return <EmptyMessage />
  if (!!loading) return <Loading />

  return false
}
